module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindents",
    staticStyle: {
      "margin-top": "8em"
    }
  }, [_vm._v("And so adrift in unknown selves we lie")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Abandoned to dark plucks of circumstance,")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Not knowing what will come or what we’ll do")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Or where the tides of sleep will wash us and")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Shy from the sculling shapes that feed on mind,")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("Feel every certainty drift out of reach")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("And sigh and hold each other, tryst with touch")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("To share what is not shareable, and know")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("The jerking terror of time’s undertow")]), _vm._v(" "), _c('p', {
    staticClass: "noindents"
  }, [_vm._v("And madly try to dream ourselves a beach.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee8537a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/08_Dedication02.vue
// module id = 75
// module chunks = 0